<script lang="ts">
	import Button from "@components/common/Button.svelte";
	import { ButtonSize } from "@components/common/ButtonSize.js";
	import Formatted from "@components/common/Formatted.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import { ButtonVariant } from "@core/schema/ButtonVariant.js";
	import { Cart } from "../../cart/Cart.svelte.js";
	import translations from "./ClearForProducts.translations.json" with { type: "json" };

	const translate = getTranslate(translations);

	const { onclear }: { onclear(this: void): void } = $props();
</script>

<p class="mt-5 text-fcrdarkgray">
	<Formatted text={translate("message")} />
</p>
<div class="flex flex-col sm:flex-row sm:justify-end gap-4 mt-8">
	<Button
		variant={ButtonVariant.Outlined}
		size={ButtonSize.Medium}
		onclick={(): void => {
			onclear();
			Cart.closeCartModal();
		}}
	>
		<Formatted text={translate("clearSubscription")} />
	</Button>
	<Button
		variant={ButtonVariant.Dark}
		size={ButtonSize.Medium}
		onclick={(): void => {
			Cart.closeCartModal();
		}}
	>
		<Formatted text={translate("ok")} />
	</Button>
</div>
